import { render } from "./ListInternalOfficeView.vue?vue&type=template&id=b93853b2"
import script from "./ListInternalOfficeView.vue?vue&type=script&lang=js"
export * from "./ListInternalOfficeView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__